module.exports = __webpack_public_path__ + "static/img/indexVersion03.592f537.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexVersion03.jpg
// module id = q0vo
// module chunks = 3